import { colors } from "./colors";

/** CSS custom properties consumed by legacy .css files. Set on :root via MuiCssBaseline. */
export const rootCssVariables = {
  "--sp-color-app-background": colors.global.appBackground,
  "--sp-color-primary-main": colors.primary.main,
  "--sp-color-primary-contrast-text": colors.primary.contrastText,
  "--sp-color-grey-100": colors.grey[100],
  "--sp-color-grey-300": colors.grey[300],
  "--sp-color-grey-500": colors.grey[500],
  "--sp-color-grey-600": colors.grey[600],
  "--sp-color-utility-white": colors.utility.white,
  "--sp-color-utility-black": colors.utility.black,
  "--sp-color-utility-grey": colors.utility.grey,
  "--sp-color-extended-link": colors.extended.link,
  "--sp-color-extended-surface-blue-alt": colors.extended.surfaceBlueAlt,
  "--sp-color-calendar-muted": colors.global.calendarMuted,
  "--sp-color-view-pdf-input-background": colors.global.viewPdfInputBackground,
  "--sp-color-error-main": colors.error.main,
  "--sp-color-export-highlight-border": colors.global.exportHighlightBorder
} as const;
